"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockShortUrl = void 0;
function mockShortUrl(overrides = {}) {
    return {
        campaign_content: null,
        campaign_medium: 'omnia-affiliate',
        campaign_name: null,
        campaign_source: 'bass-university',
        campaign_term: null,
        full_path: 'http://localhost:8080/shop?short_url=10&utm_medium=omnia-affiliate&utm_source=bass-university',
        id_hash: 'dX5J5P',
        id: 10,
        target_path: '/shop',
        ...overrides,
    };
}
exports.mockShortUrl = mockShortUrl;
